module.exports = __webpack_public_path__ + "media/images/ln/num_6-87348101a708ab0bac6e2f39364f8544.png";